import {
  errorToastClassName,
  sonnerToast,
  successToastClassName,
  appToast as toast,
} from "@/components/ui/baseUi/sonner"
import {
  DurationType,
  type PauseInputFormik,
  pauseYupValidation,
} from "@modules/boxSubscription/formik/boxSubscriptionFormik"
import { word } from "@modules/core/utils/i18n"
import { ProgramBundleSubscriberEntity } from "@modules/programBundle/programBundleSubscribers/entities/programBundleSubscriberEntity"
import { ProgramSubscriberEntity } from "@modules/programs/programSubscriber/entities/programSubscriberEntity"
import { useProgramSubscriberActions } from "@modules/programs/programSubscriber/hooks/useProgramSubscriber"
import { useFormik } from "formik"
import { useState } from "react"

export function useSubscriberPauseFormik(
  programId: string,
  subscriber: ProgramSubscriberEntity | ProgramBundleSubscriberEntity,
  moveToSubscriberDetails: () => void,
) {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const { updatePause } = useProgramSubscriberActions(programId, subscriber)

  const onSubmitForm = () => {
    setIsSubmitting(true)

    sonnerToast.promise(
      updatePause(formik.values)
        .then(() => {
          toast.success(word("program.subscribers.subscriptionDetails.pause.success"), {
            classNames: successToastClassName(),
          })
          moveToSubscriberDetails()
        })
        .catch(() => {
          toast.error(word("global.error.label"), {
            classNames: errorToastClassName(),
          })
        })
        .finally(() => {
          setIsSubmitting(false)
        }),
    )
  }

  const formik = useFormik<PauseInputFormik>({
    enableReinitialize: true,
    initialValues: {
      durationType: DurationType.MONTHLY,
      months: 1,
    },
    validationSchema: pauseYupValidation(),
    onSubmit: onSubmitForm,
  })

  return { formik, isSubmitting }
}
